import { TableHeaderCellLabelWrapper } from './TableHeaderCellLabelWrapper';

// TODO: in v9, move styled() from TableHeaderCellLabelWrapper.jsx to here
export var StyledTableHeaderCellLabelWrapper = TableHeaderCellLabelWrapper;